var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ShoppingCart = function ShoppingCart(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.069l13.071.934a1 1 0 0 1 .919 1.138l-1 7A1 1 0 0 1 19 14H7v2h10a3 3 0 1 1-2.83 2H8.83A3 3 0 1 1 5 16.17V4H4a1 1 0 0 1-1-1Zm4 3.074V12h11.133l.725-5.079L7 6.074ZM16 19a1 1 0 1 1 2 0 1 1 0 0 1-2 0ZM5 19a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ShoppingCart;